var abbreviateNumber = function (number, decPlaces) {
    if (decPlaces === void 0) { decPlaces = 2; }
    decPlaces = Math.pow(10, decPlaces);
    var abbrev = ['K', 'M', 'B', 'T'];
    for (var i = abbrev.length - 1; i >= 0; i -= 1) {
        var size = Math.pow(10, ((i + 1) * 3));
        if (size <= number) {
            number = Math.round((number * decPlaces) / size) / decPlaces;
            if (number === 1000 && i < abbrev.length - 1) {
                number = 1;
                i += 1;
            }
            number += abbrev[i];
            break;
        }
    }
    return number;
};

export { abbreviateNumber };
